SNI.Application.addModule('theme-selector', function(context) {

  return {
    behaviors: ['theme-selector']
  };

});
